import { PageLayout } from "@/components/layout/PageLayout";
import { HomeHero } from "@/components/sections/home/HomeHero";
import { NowSection } from "@/components/sections/home/NowSection";
import { FutureSection } from "@/components/sections/home/FutureSection";
import { HowSection } from "@/components/sections/home/HowSection";
import { WantNeedSection } from "@/components/sections/home/WantNeedSection";
import { AlongsideSection } from "@/components/sections/home/AlongsideSection";
import { ProofRow } from "@/components/sections/home/ProofRow";
import { ClosingCTA } from "@/components/sections/ClosingCTA";

/**
 * The homepage tells one story (story refresh, 2026-10-22): the outcome, then
 * where we are now → the future we want → how Huntbase gets you there, then
 * want vs need, "alongside, not instead of", proof, and one closing ask.
 * One idea per screen on a phone. Keep ROUTE_META["/"] in sync with the title
 * and description here.
 */
export default function HomePage() {
  return (
    <PageLayout
      title="Huntbase — Know if you've been hit. Same day, with evidence."
      description="Hunt at AI speed. Huntbase searches the security tools you already run, asks any host what was never logged, and lets Scout do the legwork while your team approves every step. The open threat-hunting platform."
    >
      {/* Outcome, mechanism, three ways forward. */}
      <HomeHero />

      {/* Now: attackers at AI speed, breaches take months to find and contain, evidence scattered */}
      <NowSection />

      {/* Future: "were we hit?" answered the same day, with evidence */}
      <FutureSection />

      {/* How: Ask / Search the tools you already run / Ask the host / Keep watching */}
      <HowSection />

      {/* Want vs need, by role */}
      <WantNeedSection />

      {/* Alongside, not instead of: SIEM, EDR, AI SOC; integration logos captioned */}
      <AlongsideSection />

      {/* Proof that is true today */}
      <ProofRow />

      <ClosingCTA
        placement="home-closing-cta"
        heading={
          <>
            Were we hit?
            <br />
            Answer it today.
          </>
        }
        description="Sign up and run a guided hunt on the sample workspace, or book a demo and bring the question you need answered."
      />
    </PageLayout>
  );
}
